// The shared policy contract.
import { ReusePolicy } from '../helpers';

/**
 * PRESERVE-ALWAYS — the cache survives every navigation.
 *
 * Never evicts on its own. The only ways the cache disappears are:
 *   - the sidebar calls `clearFor(url)` because the user clicked the menu item
 *     (so clicking a sidebar link always feels like a fresh entry), or
 *   - `clear()` is called on logout / app reset.
 *
 * This is the safest default for "I want my page state preserved when the user
 * comes back": the strategy never second-guesses what counts as the same entity.
 *
 * Used by: shg-profile, shg-meeting list, cut-off-meeting (all via
 * `reuseRoute: true`, which the dispatcher maps to this policy).
 */
export const preserveAlwaysPolicy: ReusePolicy = {
    name: 'preserveAlways',

    // Always false — keep the cache no matter what URL we're going back to.
    shouldEvict() {
        return false;
    },
};
